/**
 * The cookie banner choice. Analytics reads it to decide whether it may load,
 * and listens for changes so a click on "Accept" takes effect without a reload.
 */
export const CONSENT_STORAGE_KEY = 'yodi-cookie-consent-v1';
export const CONSENT_CHANGED_EVENT = 'yodi:cookie-consent-changed';

export type ConsentValue = 'accepted' | 'rejected';

export function parseConsent(raw: string | null | undefined): ConsentValue | null {
  return raw === 'accepted' || raw === 'rejected' ? raw : null;
}

export function readConsent(): ConsentValue | null {
  try {
    return parseConsent(localStorage.getItem(CONSENT_STORAGE_KEY));
  } catch {
    // Storage blocked (private mode, disabled cookies): treat as undecided.
    return null;
  }
}

export function writeConsent(value: ConsentValue): void {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value);
  } catch {
    // The choice still applies to this page view through the event below.
  }
  window.dispatchEvent(new CustomEvent<ConsentValue>(CONSENT_CHANGED_EVENT, { detail: value }));
}

export function onConsentChange(listener: (value: ConsentValue) => void): () => void {
  const handler = (event: Event) => {
    const value = parseConsent((event as CustomEvent<string>).detail);
    if (value) listener(value);
  };
  window.addEventListener(CONSENT_CHANGED_EVENT, handler);
  return () => window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
}
